import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import { compose } from 'utils/compose';
import { inject, observer } from 'mobx-react';
import { Section } from './styled';

const PREFIX = 'DeliveryAddress';

const classes = {
  text: `${PREFIX}-text`,
  error: `${PREFIX}-error`,
  notice: `${PREFIX}-notice`,
};

const StyledSection = styled(Section)(({ theme }) => ({
  [`& .${classes.text}`]: {
    marginTop: 0,
    fontSize: '14px',
    color: theme.colorTokens.onSurfaceTextBody,

    '&__bold': {
      fontWeight: 600,
    },
  },

  [`& .${classes.error}`]: {
    fontSize: '13px',
    color: 'red',
    fontStyle: 'italic',
  },

  [`& .${classes.notice}`]: {
    fontSize: '13px',
    color: '#f5a623',
    fontStyle: 'italic',
  },
}));

export const DeliveryAddress = compose(
  inject('store'),
  observer,
)(({ store }) => {
  const { deliveryStore } = store;
  const { delivery } = deliveryStore;

  const address = delivery?.shipment?.dropoff_address;

  return (
    <StyledSection>
      <div className="section__header">
        <p className="section__title">Delivery Address:</p>
      </div>
      <div className="section__body">
        <p className={classes.text}>{address?.street || 'N/A'}</p>
        <p className={clsx(classes.text, `${classes.text}__bold`)}>{address?.street2 || 'N/A'}</p>
        <p className={classes.text}>
          {address?.city}, {address?.state}, {address?.zipcode}
        </p>
        <span className={classes.notice}>
          Please contact <a href="mailto:support@gojitsu.com">support</a> to update your address.
        </span>
      </div>
    </StyledSection>
  );
});
